// extracted by mini-css-extract-plugin
export var fadeInOut = "_19-3";
export var icon = "_19-4";
export var savedIndicator = "_19-2";
export var savingIndicator = "_19-0";
export var spin = "_19-1";